/* ============
 * Auth
 * ============
 *
 * Auth0 authentication
 */

import Vue from 'vue'
import auth0 from 'auth0-js'

// import store from '@/app/store'

/**
 * Custom event type fix the issue with post messages emmited by another iframes
 * See more: https://github.com/auth0/auth0.js/issues/406
 * @type {string}
 */
export const customEventDataType = 'tuango_auth0_silentPostMessage'

const authZero = new auth0.WebAuth({
  domain: process.env.AUTH0_DOMAIN,
  clientID: process.env.AUTH0_CLIENT_ID,
  redirectUri: process.env.AUTH0_REDIRECT_URL,
  responseType: process.env.AUTH0_RESPONSE_TYPE,
  scope: process.env.AUTH0_SCOPE
})

const Auth = {
  login () {
    authZero.authorize({lang: 'fr'})
  },

  renew () {
    return new Promise((resolve, reject) => {
      authZero.renewAuth({
        redirectUri: process.env.AUTH0_SSO_REDIRECT_URL,
        usePostMessage: true,
        postMessageDataType: customEventDataType,
        audience: process.env.AUTH0_CLIENT_ID
      }, (err, result) => {
        console.log('Renew callback')
        if (err || result.error) {
          const error = err || result.error
          console.log('err')
          console.log(error)
          reject(error)
        } else if (result) {
          console.log('Auth result: ')
          console.log(result)
          resolve(result)
        }
      })
    })
  },

  authenticate () {
    return new Promise((resolve, reject) => {
      authZero.parseHash((err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          resolve(authResult)
        } else if (err) {
          reject(err)
        }
      })
    })
  },

  parseHash (hash, callback) {
    authZero.parseHash(hash, callback)
  },

  // syncSSOData () {
  //   setInterval(function () {
  //     // if the user is not authenticated, there is nothing to check
  //     // (i.e. the user is already logged out)
  //     if (!store.getters['auth/authenticated']) return
  //
  //     authZero.client.getSSOData(function (err, data) {
  //       // if there is still a session, do nothing
  //       if (err || (data && data.sso)) return
  //
  //       // if we get here, it means there is no session on Auth0,
  //       // then remove the token and redirect to #login
  //       console.log('SSO logout...')
  //       store.dispatch('auth/logout')
  //     })
  //   }, 5000)
  // },

  logout () {
    authZero.logout({
      federated: true,
      clientID: process.env.AUTH0_CLIENT_ID,
      returnTo: process.env.AUTH0_LOGOUT_URL
    })
  }
}

Vue.$auth = Auth
Object.defineProperty(Vue.prototype, '$auth', {
  get () {
    return Auth
  }
})



// WEBPACK FOOTER //
// ./src/app/plugins/auth.js